<template>
  <div class="count-down"
       :data-sensors-exposure-property-caseId="isPassCard ? `PSC_M` : `SKC_M`"
       data-sensors-exposure-event-name="Element_Exposure"
       :class="isPassCard ? `caseId-PSC_M` : `caseId-SKC_M`"
  >
    <div class="left">
      <span>{{ isPassCard ? '距离': '您的会员' }}</span>
      <span>{{ amount }}元{{countDownInfo.countDownType === 'PassCard' ? '免审额度' : '红包'}}</span>
      <span>{{ isPassCard ? '失效' : '即将失效'}}</span>
      <van-count-down :time="duration" @finish="countDownEnd">
        <template #default="timeData">
          <span class="block">{{ timeFormat(timeData.hours) }}</span>
          <span class="colon">:</span>
          <span class="block">{{ timeFormat(timeData.minutes) }}</span>
          <span class="colon">:</span>
          <span class="block">{{ timeFormat(timeData.seconds) }}</span>
        </template>
      </van-count-down>
    </div>
    <div class="right" @click="useAction">去使用 ></div>
    <div class="close" @click="countDownEnd"></div>
  </div>
</template>

<script>
import { CountDown } from 'vant'
import { setKey } from '@/assets/utils'
import CountDownTool from '@/assets/CountDownTool'
export default {
  props: {
    countDownInfo: {
      type: Object,
      default: null
    }
  },
  computed: {
    duration () {
      return this.countDownInfo.remainTime
    },
    amount () {
      return this.countDownInfo.amount
    },
    isPassCard () {
      return this.countDownInfo.countDownType === 'PassCard'
    }
  },
  components: {
    CountDown
  },
  methods: {
    countDownEnd () {
      this.$emit('didFinished')
    },
    timeFormat (num) {
      if (num < 10) {
        return `0${num}`
      }
      return num === 0 ? '00' : num
    },
    useAction () {
      if (this.countDownInfo.countDownType === 'PassCard') {
        this.$router.push('/middle/limit')
      } else {
        this.jumpToKingCardPage()
      }
    },
    closeAction () {
      this.countDownEnd()
      setKey(CountDownTool.Keys.HomeCountDownEndTime, Date.now())
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.count-down {
  width: 100%;
  height: 80px;
  background: rgba(0, 0, 0, 0.8);
  padding: 0 10px 0 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  .left {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .amount {
      color: #FF4633;
    }
    .van-count-down {
      margin: 0 5px;
      .colon {
        font-size: 28px;
        color: #fff;
      }
      .block {
        display: inline-block;
        width: 45px;
        height: 50px;
        background: #C92E10;
        border-radius: 4px;
        text-align: center;
        font-size: 28px;
        line-height: 50px;
        color: #fff;
      }
    }
  }
  .right {
    height: 80px;
    border-radius: 18px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 80px;
    text-align: center;
  }
  .close {
    width: 24px;
    height: 24px;
    background: url(./images/count-down-close.png) no-repeat center center;
    background-size: cover;
    margin-top: 10px;
  }
}
</style>